import React from 'react';
import { createPortal } from 'react-dom';

type TPortalWrapper = {
  children: React.ReactNode;
  id?: string;
};

export const PortalWrapper = (props: TPortalWrapper) => {
  const { children, id = 'portal' } = props;
  /*   const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  } */

  const portalRoot = document.getElementById(id);

  if (!portalRoot) {
    return null;
  }

  return createPortal(children, portalRoot);
};
